module.exports = __webpack_public_path__ + "static/media/diners.4d412ce9.svg";